module.exports = __webpack_public_path__ + "img/流体力学6_1.d6716668.jpg";